import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces';
import { ButtonSize, ButtonTheme, IconPosition, ModalButtons, NotificationLayout } from '@fcom/ui-components';
import { ExtendedFareFamily } from '@fcom/common-booking/interfaces';
import { GtmService } from '@fcom/common/gtm';

@Component({
  selector: 'fin-multi-city-journey-price',
  templateUrl: './multi-city-journey-price.component.html',
  styleUrls: ['./multi-city-journey-price.component.scss'],
})
export class MultiCityJourneyPriceComponent {
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly ElementTypes = ElementTypes;
  readonly IconPosition = IconPosition;
  readonly NotificationLayout = NotificationLayout;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TRACKING_CONTEXT = GaContext.BOOKING_FLOW;
  readonly ModalButtons = ModalButtons;

  @Input() fareFamily: ExtendedFareFamily;
  @Input() price: string;
  @Output() resetSelection = new EventEmitter();

  modalOpen = false;
  changeTicketTypeModalOpen = false;

  constructor(private gtmService: GtmService) {}

  openInfoModal(): void {
    this.modalOpen = true;

    this.gtmService.trackElement(
      'multicity-ticket-type-info-modal',
      GaContext.FLIGHT_SELECTION,
      ElementTypes.BUTTON,
      '',
      ElementActions.CLICK
    );
  }

  openResetWarningModal(): void {
    this.changeTicketTypeModalOpen = true;

    this.gtmService.trackElement(
      'multicity-change-ticket-type',
      GaContext.FLIGHT_SELECTION,
      ElementTypes.BUTTON,
      '',
      ElementActions.CLICK
    );
  }
}
